import {
  MDSButton,
  MDSButtonVariant,
  MDSButtonGroup,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";

interface DeleteRecordingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteRecordingModal = ({ isOpen, onClose, onDelete }: DeleteRecordingModalProps) => {
  return (
    <MDSModalDialog isOpen={isOpen} handleClose={onClose}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Delete recording
      </MDSText>

      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>
          Are you sure you want to delete this recording and transcript? This cannot be undone.
        </MDSText>
      </MDSDialogTextContent>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={onClose}>Cancel</MDSButton>
        <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={onDelete}>
          Delete
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
};
